import styled from "@emotion/styled";

import { commonColors } from "application/theme";
import { SimpleConfirmModalProps } from "./models";

interface StyledProps {
  buttonsDirection: SimpleConfirmModalProps["buttonsDirection"];
}

export const Container = styled("div")`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled("div")`
  display: flex;
  flex-direction: column;
  margin: 0 16px;
  padding: 40px 20px;
  border-radius: 32px;
  background: ${commonColors.white};

  h4 {
    /* font */
    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
    text-align: center;
    color: ${commonColors.grey900};
  }
`;

export const ButtonsSection = styled("div")<StyledProps>`
  gap: 12px;
  display: flex;
  flex-direction: ${({ buttonsDirection }) =>
    buttonsDirection === "row" ? "row-reverse" : "column"};

  button {
    flex: ${({ buttonsDirection }) => (buttonsDirection === "row" ? 1 : "initial")};
  }
`;

export const Description = styled("p")`
  margin-top: 24px;
  margin-bottom: 32px;
  /* font */
  font-size: 18px;
  font-weight: 400;
  line-height: 130%;
  text-align: center;
  color: ${commonColors.grey900};
`;
